<template>
  <div>
    <Card class="tw-max-w-2xl">
      <template #title>Display</template>
      <template #subtitle>
        Browser preferences only. MLS feeds, auth, destinations, and cron live in Config — no config.js editing required.
      </template>
      <template #content>
        <div class="field-row">
          <InputSwitch v-model="useRelativeTime" inputId="useRelativeTime" />
          <label for="useRelativeTime">
            Use relative time (e.g. <em>4 minutes ago</em>) instead of absolute timestamps
          </label>
        </div>
        <Button label="Open Config" icon="pi pi-sliders-h" class="p-button-outlined" @click="$router.push('/config')" />
      </template>
    </Card>
  </div>
</template>

<script>
import { makeGlobalSettings } from '../lib/utils/index'

export default {
  computed: {
    ...makeGlobalSettings({
      useRelativeTime: 'useRelativeTime',
    }),
  },
}
</script>
